<style  scoped>



</style>

<template>

<div class="c-sliced-text u-relative u-force-inline u-force-3d u-fit-w">
   <div class="c-sliced-text__base" v-html="content"></div>
</div>

</template>

<script>

 export default {
    name: "app-sliced-text",
    props: {
      debug: {
        type: Boolean,
        default: !1
    },
        content: {
            type: String,
            default: ""
        }
    },
    data: function() {
        return {
            width: 0

        }
    },
    created: function() {
        this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {
        this.onResize()
    },
    methods: {
        onResize: function() {
            this.width = this.$el.offsetWidth
        }
    },
    computed: {
        stylesComputed: function() {
            return {
                width: this.width + 'px'
            }},
            stylesComputed1: function() {
                return {
                    width: this.width /3+50+ 'px'
                }
            },
            stylesComputed2: function() {
                return {
                    width: this.width /3+ 'px'
                }
            },
            stylesComputed3: function() {
                return {
                    width: this.width /3+20+ 'px'
                }
            }
    }

}

</script>
